import { queryOptions } from '@tanstack/react-query'

const CURRENT_BUILD_ID = __BUILD_ID__

export const versionCheck = {
  current: () =>
    queryOptions({
      queryKey: ['version-check'],
      queryFn: async (): Promise<string | null> => {
        const res = await fetch('/version.json', { cache: 'no-store' })
        if (!res.ok) {
          return null
        }
        const { buildId } = await res.json()
        return typeof buildId === 'string' ? buildId : null
      },
      staleTime: 0, // Always refetch on window focus to detect new deployments
      enabled: !import.meta.env.DEV,
    }),
}

export function hasNewVersion(
  latestBuildId: string | null | undefined
): boolean {
  return (
    !import.meta.env.DEV &&
    typeof latestBuildId === 'string' &&
    latestBuildId !== CURRENT_BUILD_ID
  )
}
